import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/**
 * Napisy paginatora Material w jezyku panelu (COMMON.PAGINATOR.*). Bez tego kazda tabela
 * pokazywala "Items per page" i "1 – 50 of 200" po angielsku, takze w PL i ES (Hubert 17.09).
 *
 * Podany w AppModule: MatPaginatorModule w modulach lazy bierze instancje z rodzica
 * (Optional + SkipSelf), wiec jeden provider obejmuje wszystkie tabele.
 */
@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private readonly sub: Subscription;

  constructor(private readonly translate: TranslateService) {
    super();
    this.sub = this.translate.onLangChange.subscribe(() => this.apply());
    // pierwszy zestaw po zaladowaniu pliku jezyka (onLangChange przy starcie moze juz minac)
    this.translate.get('COMMON.PAGINATOR.NEXT').subscribe(() => this.apply());
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (!length || !pageSize) return this.translate.instant('COMMON.PAGINATOR.RANGE_EMPTY', { total: length || 0 });
    const start = page * pageSize;
    const end = Math.min(start + pageSize, length);
    return this.translate.instant('COMMON.PAGINATOR.RANGE', { start: start + 1, end, total: length });
  };

  private apply(): void {
    this.itemsPerPageLabel = this.translate.instant('COMMON.PAGINATOR.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('COMMON.PAGINATOR.NEXT');
    this.previousPageLabel = this.translate.instant('COMMON.PAGINATOR.PREVIOUS');
    this.firstPageLabel = this.translate.instant('COMMON.PAGINATOR.FIRST');
    this.lastPageLabel = this.translate.instant('COMMON.PAGINATOR.LAST');
    this.changes.next();
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }
}
